"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ARR_COLUMN_SPAN = exports.PRODUCT_TYPE = exports.TOKENS = exports.COOKIE_NAME = exports.MULTI_LOB_ID = void 0;
var MULTI_LOB_ID = {
  FLIGHTS: 'multilob_flights',
  HOTEL: 'multilob_hotels',
  SNAP: 'multilob_snap',
  ACTIVITIES: 'multilob_activities'
};
exports.MULTI_LOB_ID = MULTI_LOB_ID;
var COOKIE_NAME = {
  FLIGHT_RECENT_SEARCHES: 'flightRecentSearch',
  UHF_LOCALE: 'uhfLocale',
  UHF_CURRENCY: 'uhfCurrency'
};
exports.COOKIE_NAME = COOKIE_NAME;
var TOKENS = {
  DEFAULT_IMAGE_WIDTH: '100%',
  PRIMARY_LABEL: {
    TYPE: 'primary'
  },
  SECONDARY_LABEL: {
    TYPE: 'secondary'
  },
  ATTRACT_TEXT: {
    COLOR: 'secondaryDark',
    SIZE: 'small'
  },
  TITLE: {
    SIZE: 'default',
    COLOR: 'neutral'
  },
  SUBTITLE: {
    SIZE: 'small',
    COLOR: 'neutral'
  },
  STARS: {
    COLOR: 'yellow',
    MAX_RATE: 5,
    STAR_SIZE: 'normal',
    TYPE: 'full'
  },
  LOCATION: {
    COLOR: 'greyDark',
    SIZE: 'small',
    ICON: 'LocationOnIcon',
    ICON_COLOR: 'greyDark'
  },
  RATING: {
    COLOR: 'secondaryDark'
  },
  CTA: {
    COLOR: 'primary',
    TARGET_TYPE: {
      TAB: 'tab',
      PARENT: 'parent'
    }
  },
  PRICE_DISCLAIMER: {
    COLOR: 'greyDark',
    SIZE: 'small'
  },
  DISCOUNT: {
    COLOR: 'tertiary',
    SIZE: 'sub'
  },
  ORIGINAL_PRICE: {
    COLOR: 'greyDark',
    SIZE: 'sub'
  },
  PRICE: {
    COLOR: 'neutral',
    DECIMAL_TYPE: 'DEFAULT'
  },
  PRICE_CLARIFICATION: {
    COLOR: 'greyDark',
    SIZE: 'sub'
  }
};
exports.TOKENS = TOKENS;
var PRODUCT_TYPE = {
  BUTTON: 'button',
  LINK: 'link'
};
exports.PRODUCT_TYPE = PRODUCT_TYPE;
var ARR_COLUMN_SPAN = ['2', '3', '4', '1'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;